import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './right.styl'

export default class Right extends Component {
  static propTypes = {
    children: PropTypes.any
  }

  render() {
    return (
      <div className={styles.wrap}>
        {this.props.children}
      </div>
    )
  }
}
